export default "__VITE_ASSET__2a4ef7ce__"